import React from "react";
import { Link, useParams } from "react-router-dom";
import _axios from "../../../httpService";

const MyComponent = () => {
  const params = useParams();

  _axios.get(``).then((response) => {
    console.log(response);
  });

  return (
    <div>
      <Link to={"/Dashboard"}> داشبورد اصلی </Link>
      سلام اینجا روی دسته بندی کلیک شده و این صفحه در اختیار شماست. لینک دسته
      بندی کلیک شده چیه؟
      <br />
      {params.id}
      <br />
      {params.level} <br />
      {params.code}
    </div>
  );
};

export default MyComponent;
